import { initialsFromName } from '@amumin/domain';

// 0057 (oprichter 1 okt): initialen per gezinslid ("A" voor Anne, "OA" voor Omer Asaf). Ze staan in
// de agenda achter de titel. In de formulieren volgt het veld de naam tot de ouder er zelf in typt.

export { initialsFromName };

/** Wat de ouder typt: zonder spaties, punten en streepjes, in hoofdletters, hooguit drie letters. */
export function normalizeInitials(value: string): string {
  return Array.from(value.replace(/[\s.\-']/g, '').toUpperCase())
    .slice(0, 3)
    .join('');
}

/** Eén tot drie letters (elk schrift), zoals de server (MemberInitials) eist. */
export function isValidInitials(value: string): boolean {
  return /^\p{L}{1,3}$/u.test(value);
}

/** Initialen van een lid; een lid van vóór 0057 of uit een oude cache: uit de naam. */
export function memberInitials(m: { initials?: string | null; display_name: string }): string {
  return m.initials || initialsFromName(m.display_name);
}

/**
 * Volgt het veld nog de naam? Ja bij een nieuw lid, en bij een bestaand lid waarvan de initialen
 * gelijk zijn aan wat de naam geeft (dan verandert een nieuwe naam ze gewoon mee).
 */
export function followsName(initials: string, name: string): boolean {
  return initials === '' || initials === initialsFromName(name);
}
